import { render } from "./cartView.vue?vue&type=template&id=20fe516c&scoped=true"
import script from "./cartView.vue?vue&type=script&lang=js"
export * from "./cartView.vue?vue&type=script&lang=js"

import "./cartView.vue?vue&type=style&index=0&id=20fe516c&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fe516c"]])

export default __exports__